/**************************************************
 * Nombre:       PorMayor_Franquisia
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import logo from '../../../Recursos/logo_color.svg'
import franqui1 from '../../../Recursos/franquicia1.png'
import franqui2 from '../../../Recursos/franquicia2.png'
import {NEGRITA} from "../../../Constantes";
import {theme} from "../../../Tema";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";


const PorMayor_Franquisia = () => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{justifyContent: !masSM ? 'center' : 'flex-start', mb: -6, mt: 2}}>
                            <img src={logo} width={sCell ? 240 : 350} height={'auto'}/>
                        </Grid>


                        <Grid container size={{xs: 12, sm: 12, md: 6}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start', mt: 0}}>
                            {/*} <Typography sx={{
                                fontFamily: NEGRITA,
                                fontSize: sCell ? 32 : 48,
                                color: theme.palette.primary.main,
                                lineHeight: 1.1,
                                textAlign: 'center'
                            }}>Por
                                que
                                {sCell && <br/>}
                                nuestros aliados
                                <br/> lo pidieron <span style={{
                                    color: theme.palette.info.main,
                                    margin: 8,
                                    border: 1,
                                    stroke: 2,
                                    textShadow: '2px 2px 0px  #000, -2px -2px 0px  #000, 2px -2px 0px  #000, -2px 2px 0px  #000'
                                }}>proximamente</span>
                                {sCell && <br/>}
                                franquicia
                            </Typography>*/}
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 4, md: 4}}
                              sx={{justifyContent: 'flex-start', mt: 8, pr: 4}}>
                            <Typography sx={{fontSize: 18, fontWeight: 600, textAlign: sCell ? 'center' : 'left'}}>
                                Prepárate para obtener tu franquicia y llevar el sabor auténtico de Ipiales a más
                                lugares, con el respaldo de una marca sólida y llena de pasión.
                            </Typography>

                        </Grid>

                        <Grid container size={{xs: 12, sm: 8, md: 8}} sx={{justifyContent: 'flex-start', mt: sCell ? 8 : 4}}>
                            <img src={franqui1} width={'100%'} height={'auto'} style={{borderRadius: 30}}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start', mt: sCell ? 8 : -40}}>
                            <img src={franqui2} width={'100%'} height={'auto'} style={{borderRadius: 30}}/>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default PorMayor_Franquisia